import React from 'react';

import { Container, Left, Right, Title, Subtitle, NameCompany } from './styles';

interface Props {
  title: string;
  subtitle?: string;
  nameCompany?: string;
  right?: any;
}

const ScreenHeader = ({ title, subtitle, nameCompany, right }: Props) => (
  <Container>
    <Left>
      <Title>{title}</Title>
      {nameCompany && <NameCompany>{nameCompany}</NameCompany>}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Left>
    {right && <Right>{right}</Right>}
  </Container>
);

export default ScreenHeader;
